import angular from 'angular';
import { MeurhSolicitacoesalteracoesvtstarifasFormController } from './solicitacoesalteracoesvtstarifas.form.controller';

export class MeurhSolicitacoesalteracoesvtstarifasFormComponent implements angular.IComponentOptions {
    static selector = 'meurhSolicitacoesalteracoesvtstarifasFormComponent';
    static controller = MeurhSolicitacoesalteracoesvtstarifasFormController;
    static template = require('html-loader!./solicitacoesalteracoesvtstarifas.form.html');
    static transclude = true;
    static bindings = {
        entity: '<',
        form: '<',
        action: '<',
        entitiesexcluidas: '<',
        params: '<',
    };
}
